/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const createPresignedUploadUrlRequestSchema = z.object({
  originalFilename: z.string(),
  size: z.int(),
  usage: z.enum(['TEAMS', 'CONFIG']),
});
